import Button from './Button';

interface Iprops {
  onClick: any;
  title: string;
  icon?: any;
}

const ButtonChangeBg = ({ onClick, title, icon }: Iprops) => {
  return <Button title={title} iconBefore={icon} handleOnclick={onClick} />;
};

export default ButtonChangeBg;
